module.exports = __webpack_public_path__ + "img/exos10_26.db53aff2.png";